import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Popconfirm} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import Process from './process';
import View from './view';
import Print from './print';
import {
  createResource,
  deleteResource,
  fetchLastProcessedResource,
  fetchResource,
  getResource,
  getResourceForDownload,
  processList,
  saveResourceQuery,
  updateResource
} from "../../appRedux/actions/PreventiveMaintenance";
import {fetchResource as fetchServiceIdentifier} from "../../appRedux/actions/ServiceIdentifier";
import {
  fetchFilter,
  fetchSubDocumentFilter,
  getServiceIdentifierFromAsset,
  searchGlobalAssetData
} from '../../appRedux/actions';
import {getResource as getManpowerList} from '../../appRedux/actions/Manpower';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';
import BlankPrint from "./print_blank";
import ChecklistUpload from "../ServiceIdentifier/import";

export class PMChecklist extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {hasProcessed: '{"value":[false],"type":"Boolean","field":"hasProcessed"}'}
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset)
      })
    });

    columns.push({
      title: 'Action',
      key: 'actions',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button style={{marginLeft: '5px'}} icon={'eye'} type="default" size='small'
                           onClick={() => this.view(record._id)}/>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button style={{marginLeft: '5px'}} icon={'printer'} type="default" size='small'
                           onClick={() => this.print(record._id)}/>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button style={{marginLeft: '5px'}} disabled={record.hasProcessed || false} type="primary"
                           size='small'
                           onClick={() => this.edit(record._id)}>Process</Button>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={() => {
                this.deleteResource(record._id)
              }}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={record.hasProcessed || false} style={{marginLeft: '10px'}} type="danger"
                      size='small'>Delete</Button>
            </Popconfirm>
          }}/>

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    this.props.updateResource(values, id);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/process/${id}`);
  };

  view = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/view/${id}`);
  };

  print = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/print_blank/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "Task");
  }

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>PM Checklist</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   visibleColumn={visibleColumns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   downloadToCSV={this.downloadToCSV}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          loading={loading}
                                          getServiceIdentifierFromAsset={this.props.getServiceIdentifierFromAsset}
                                          identifiers={this.props.identifiers}
                                          fetchServiceIdentifier={this.props.fetchServiceIdentifier}
                                          identifierData={this.props.siData}
                                          fetchLastProcessed={this.props.fetchLastProcessedResource}
                                          lastProcessedResource={this.props.lastProcessedResource}

                                          authUser={this.props.authUser}
                                          assetData={this.props.assetData}
                                          assetSearchLoading={this.props.assetSearchLoading}
                                          searchGlobalAssetData={this.props.searchGlobalAssetData}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/process/:id`}
               render={(props) => <Process data={edit}
                                           filters={filters}
                                           modules={modules}
                                           title={'PROCESS'}
                                           resource={resourceName}
                                           fetch={fetchResource}
                                           onChange={this.handleFormChange}
                                           onSubmit={this.updateResource}
                                           loading={loading}
                                           taskUpdateData={this.props.taskUpdateData}
                                           process={this.props.processList}
                                           isProcessDone={this.props.isProcessDone}
                                           getManpowerList={this.props.getManpowerList}
                                           manpowerList={this.props.manpowerList}
                                           fetchLastProcessed={this.props.fetchLastProcessedResource}
                                           lastProcessedResource={this.props.lastProcessedResource}
                                           subDocumentFilters={this.props.subDocumentFilters}
                                           {...props}
               />
               }/>

        <Route path={`${match.url}/view/:id`}
               render={(props) => <View data={edit}
                                        filters={filters}
                                        modules={modules}
                                        title={'VIEW'}
                                        resource={resourceName}
                                        fetch={fetchResource}
                                        onChange={this.handleFormChange}
                                        onSubmit={this.updateResource}
                                        fetchLastProcessed={this.props.fetchLastProcessedResource}
                                        lastProcessedResource={this.props.lastProcessedResource}
                                        loading={loading}
                                        {...props}
               />
               }/>

        <Route path={`${match.url}/print/:id`}
               render={(props) => <Print data={edit}
                                         filters={filters}
                                         modules={modules}
                                         title={'Print'}
                                         resource={resourceName}
                                         fetch={fetchResource}
                                         loading={loading}
                                         authUser={this.props.authUser}
                                         {...props}
               />
               }/>

        <Route path={`${match.url}/print_blank/:id`}
               render={(props) => <BlankPrint data={edit}
                                              filters={filters}
                                              modules={modules}
                                              title={'Print'}
                                              resource={resourceName}
                                              fetch={fetchResource}
                                              loading={loading}
                                              authUser={this.props.authUser}
                                              {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, preventiveMaintenance, serviceIdentifier, manpower, commonData}) => {
  return {
    authUser: auth.authUser,
    total: preventiveMaintenance.total,
    data: preventiveMaintenance.resources,
    resource: preventiveMaintenance.resource,
    edit: preventiveMaintenance.edit,
    query: preventiveMaintenance.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    identifiers: serviceIdentifier.data,
    siData: serviceIdentifier.resource,
    lastProcessedResource: preventiveMaintenance.lastProcessedResource,
    taskUpdateData: preventiveMaintenance.taskUpdateData,
    isProcessDone: preventiveMaintenance.isProcessDone,
    manpowerList: manpower.resources,
    subDocumentFilters: commonData.subDocumentFilters,

    assetData: commonData.assetSearchData,
    assetSearchLoading: commonData.assetSearchLoading,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    getServiceIdentifierFromAsset,
    fetchServiceIdentifier,
    fetchLastProcessedResource,
    processList,
    getManpowerList,
    fetchSubDocumentFilter,
    searchGlobalAssetData
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(PMChecklist);
